function deleteScript(id) {
  let script = document.querySelector(id);
  !!script && script.remove();
}

function loadCrisp() {
  if (typeof $crisp !== 'undefined')
    return;

  deleteScript('#crisp-script');
  window.$crisp=[];window.CRISP_WEBSITE_ID="4a2be073-1162-474c-818e-d04dbc3bdd23";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.id='crisp-script';s.defer=1;s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
  setTimeout(() => {
    $crisp.push(["do", "chat:hide"]);
    $crisp.push(["set", "user:email", [Traus.company.user.email, Traus.company.user.hmac_signed_key]]);
    $crisp.push(["set", "user:segments", [Traus.company.user.role]]);
    $crisp.push(["set", "user:company", [Traus.company.name, {
      url: `https://${Traus.company.sub_domain}.traus.com.br/`
    }]]);
  }, 100);
}

function loadIntegrations() {
  loadCrisp();
}

try {
  if (Traus.company.user.role !== 'student') {
    document.addEventListener("turbo:frame-load", loadIntegrations);
    document.addEventListener("turbo:load", loadIntegrations);
  }
} catch (ex) {
  console.error(ex)
}